__turbopack_context__.v({
  "fallback": "page-module-scss-module__yye4Xq__fallback",
  "main": "page-module-scss-module__yye4Xq__main",
});
